export enum LayerType {
  raster = <any>'raster',
  vector = <any>'vector',
  interactive = <any>'interactive',
  combined = <any>'combined'
}
